export enum FormApprovalType {
  DocLogixApproval = 1,
  ManagerApproval = 2,
  CEOApproval = 3,
  DefaultSignersApproval = 4,
  OwnerApproval = 5,
}
